import React, {Component} from "react";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words";
import { Row, Col } from "antd";
import PropTypes from 'prop-types';
import TransactionDetailsTable from "./../Components/TransactionDetailsTable/TransactionDetailsTable.js";
import { TableData } from "./../Components/TransactionDetailsTable/styles";
import {
  ColumnHeader
} from "./../Components/BalanceDetailsTable/styles.js";
import CardComponent from "./../Components/CardComponent/CardComponent.js";
import TitleNode from "./../Components/CardComponent/TitleNode.js";
import { DataVal, TxnVal } from "./../Components/CardComponent/styles.js";
import formatter from './../../../utils/formatter';
import { milliToDate, formatShares, formatSharesWithSixDecimal, checkIEBrowser, recordError } from './../../../utils/commonUtil';
import { selectHeader } from "../../../actions/globalActions";
import history from "./../../../history/history";
import { renderDate } from "../Pages/txnUitls";

class ContributionsTable extends Component {
  constructor(props) {
    super(props)
    this.renderTxnView = this.renderTxnView.bind(this)
    this.renderText = this.renderText.bind(this)
  }
  renderAmount = (text, data) => {
    if (text && text > 0 || text < 0) {
      let dollarsAmount = formatter({
        value: text,
        fieldSuffix: 'Dollars',
      });

      return (
        <TableData>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[this.props.searchText]}
            autoEscape
            textToHighlight={data.status === "Reversed" ? `(${dollarsAmount})` : dollarsAmount}>
            {data.status === "Reversed" ? `(${dollarsAmount})` : dollarsAmount}
          </Highlighter>
        </TableData>
      )
    } else if (text === 0) {
      return (<TableData>$0.00</TableData>)
    } else {
      return (<TableData>-</TableData>);
    }
  }

  renderText = (text) => {
    if (text) {
      return (
        <TableData ie={checkIEBrowser()} break>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[this.props.searchText]}
            autoEscape
            textToHighlight={text}>
            {text}
          </Highlighter>
        </TableData>
      )
    } else {
      return (<TableData>-</TableData>);
    }

  }
  renderShare = (share, record) => {
    let text = share ? (record.type === "Special Asset" ? formatSharesWithSixDecimal(share) : formatShares(share)) : '-';
    return (
      <TableData>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[this.props.searchText]}
          autoEscape
          textToHighlight={text}>
          {text}
        </Highlighter>
      </TableData>
    )
  }
  renderTxnView(txnId, data) {
    if (txnId) {
      if (data.reversal === true) {
        return (
          <TableData>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[this.props.searchText]}
              autoEscape
              textToHighlight={txnId}>
              {txnId}
            </Highlighter>
          </TableData>
        )
      } else {
        return (
          <>
            <TxnVal onClick={() => this.goToTxnView(txnId, data)}>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[this.props.searchText]}
                autoEscape
                textToHighlight={txnId}>
                {txnId}
              </Highlighter>
            </TxnVal>
          </>
        )
      }
    } else {
      return (<TxnVal>-</TxnVal>);
    }
  }

  goToTxnView = (txnId, data) => {
    try {
      this.props.selectHeader('Contribution Activity');
      history.push({ pathname: '/contributions/activity/view', state: { transactionId: txnId, status: data.status, giftId: data.giftId } });
    } catch (error) {
      recordError(error);
    }
  }

  renderTitleGrid = pool => {
    return (
      <>
        <TitleNode title='Entered Date' />
        <DataVal>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[this.props.searchText]}
            autoEscape
            textToHighlight={`${pool}*`}>{pool ? pool : '-'}</Highlighter>
        </DataVal>
      </>
    );
  };

  renderFixGrid = ({ each, gridName, type }) => {
    switch (type) {
      case 'date':
        return (
          <>
            <TitleNode title={gridName} />
            <DataVal>
              {
                (each[gridName] !== null && each[gridName] !== undefined)
                  ?
                  <Highlighter
                    highlightStyle={{
                      color: "black",
                      fontWeight: 600,
                      backgroundColor: "transparent"
                    }}
                    searchWords={[this.props.searchText]}
                    autoEscape
                    textToHighlight={milliToDate(each[gridName])}>
                    {milliToDate(each[gridName])}
                  </Highlighter>
                  : '-'
              }
            </DataVal>
          </>
        )
      case 'amount':
        let dollarsAmount = formatter({
          value: each[gridName],
          fieldSuffix: 'Dollars',
        });
        return (
          <>
            <TitleNode title='Dollar amount' />
            <DataVal>
              {
                (each[gridName] !== null && each[gridName] !== undefined)
                  ?
                  <Highlighter
                    highlightStyle={{
                      color: "black",
                      fontWeight: 600,
                      backgroundColor: "transparent"
                    }}
                    searchWords={[this.props.searchText]}
                    autoEscape
                    textToHighlight={dollarsAmount}>
                    {dollarsAmount}
                  </Highlighter>
                  : '-'
              }
            </DataVal>
          </>
        )
      case 'number':
        let value = each[gridName] + '';
        return (
          <>
            <TitleNode title={gridName} />
            <DataVal>
              {
                (each[gridName] !== null && each[gridName] !== undefined)
                  ?
                  <Highlighter
                    highlightStyle={{
                      color: "black",
                      fontWeight: 600,
                      backgroundColor: "transparent"
                    }}
                    searchWords={[this.props.searchText]}
                    autoEscape
                    textToHighlight={each.type === "Special Asset" ? formatSharesWithSixDecimal(value) : formatShares(value)}>
                    {each.type === "Special Asset" ? formatSharesWithSixDecimal(value) : formatShares(value)}
                  </Highlighter>
                  : '-'
              }
            </DataVal>
          </>
        )
      default:
        return (
          <>
            <TitleNode title={gridName} />
            <DataVal>
              {
                (each[gridName] !== null && each[gridName] !== undefined)
                  ?
                  <Highlighter
                    highlightStyle={{
                      color: "black",
                      fontWeight: 600,
                      backgroundColor: "transparent"
                    }}
                    searchWords={[this.props.searchText]}
                    autoEscape
                    textToHighlight={each[gridName]}>
                    {each[gridName]}
                  </Highlighter>
                  : '-'
              }
            </DataVal>
          </>
        )
    }
  };

  render() {
    const columns = [
      {
        title: <ColumnHeader>Transaction ID</ColumnHeader>,
        render: this.renderTxnView,
        dataIndex: "transactionId",
        key: "transactionId",
        width: 100,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => { return a.transactionId.localeCompare(b.transactionId) }
      },
      {
        title: <ColumnHeader>Entered Date</ColumnHeader>,
        render: (date) => renderDate(date, this.props.searchText),
        dataIndex: "enteredDate",
        key: "enteredDate",
        width: 100,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => { return a.enteredDate - b.enteredDate }
      },
      {
        title: <ColumnHeader>Description</ColumnHeader>,
        render: this.renderText,
        dataIndex: "description",
        key: "description",
        width: 100,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => { return a.description.localeCompare(b.description) }
      },
      {
        title: <ColumnHeader>Shares</ColumnHeader>,
        render: (text, record) => this.renderShare(text, record),
        dataIndex: "noOfShares",
        key: "noOfShares",
        width: 120,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => { return a.noOfShares - b.noOfShares }
      },
      {
        title: <ColumnHeader>Amount</ColumnHeader>,
        render: this.renderAmount,
        dataIndex: "amount",
        key: "amount",
        width: 120,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => a.amount - b.amount
      },
      {
        title: <ColumnHeader>Received Date</ColumnHeader>,
        render: (date) => renderDate(date, this.props.searchText),
        dataIndex: "receivedDate",
        key: "receivedDate",
        width: 100,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => { return a.receivedDate - b.receivedDate }
      },
      {
        title: <ColumnHeader>Trade Date</ColumnHeader>,
        render: (date) => renderDate(date, this.props.searchText),
        dataIndex: "tradeDate",
        key: "tradeDate",
        width: 100,
        sortDirections: ["ascend", "descend"],
        sorter: (a, b) => { return a.tradeDate - b.tradeDate }
      }
    ];
    const destObj = (each, index) => {
      return [
        {
          name: "TransactionId",
          type: "FixGrid",
          gridWidth: "50",
          render: this.renderTxnView(each['transactionId'], each),
          ptop: true,
          pbottom: true,
          pleft: true
        },
        {
          name: "EnteredDate",
          gridWidth: "100",
          type: "FixGrid",
          render: this.renderTitleGrid(milliToDate(each.enteredDate)),
          ptop: true,
          pbottom: true,
          pright: true
        },
        {
          name: "Description",
          type: "FixGrid",
          gridWidth: "50",
          render: this.renderFixGrid({
            each,
            gridName: "description"
          }),
          ptop: true,
          pbottom: true,
          pleft: true
        },
        {
          name: "Shares",
          type: "FixGrid",
          gridWidth: "50",
          render: this.renderFixGrid({ each, gridName: "noOfShares", type: 'number' }),
          ptop: true,
          pbottom: true,
          pleft: true
        },
        {
          name: "Amount",
          type: "FixGrid",
          gridWidth: "50",
          render: this.renderFixGrid({ each, gridName: "amount", type: 'amount' }),
          ptop: true,
          pbottom: true,
          pleft: true
        },
        {
          name: "ReceivedDate",
          type: "FixGrid",
          gridWidth: "50",
          render: this.renderFixGrid({ each, gridName: "receivedDate", type: 'date' }),
          ptop: true,
          pbottom: true,
          pleft: true
        },
        {
          name: "TradeDate",
          type: "FixGrid",
          gridWidth: "50",
          render: this.renderFixGrid({ each, gridName: "tradeDate", type: 'date' }),
          ptop: true,
          pbottom: true,
          pleft: true
        }
      ];
    };
    return (
      <Row id={"table-search-contributions"} data-test="transaction-contributions-table">
        <Col lg={24} md={0} xs={0}>
          <TransactionDetailsTable data-test="transaction-contributions-table-desktop" className="contributionsTab" tabIdentifier="Contributions" alignAmountColumn tabName="contributions" scroll={{ y: 500 }} columns={columns} data={this.props.contributionsData} searchText={this.props.searchText} />
        </Col>
        <Col lg={0} md={24} xs={24} className="mobCard">
          <CardComponent data-test="transaction-contributions-table-mobile" tabName="contributions" destObj={destObj} data={this.props.contributionsData} searchText={this.props.searchText} />
        </Col>
      </Row>
    );
  }
};

ContributionsTable.propTypes = {
  searchText: PropTypes.string,
  contributionsData: PropTypes.array
}

const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data)),
  };
};

export default connect(null, mapDispatchToProps)(ContributionsTable);
